export default __webpack_public_path__ + "static/media/info-password-security.71a82249.gif";